<template>
  <div id="searchTree">
    <span><Icon type="ios-apps" size="16" color="#9999A4"/>部门组织架构</span>
    <div v-if="data1.length == 0">
      <span style="color:#DCDCDC;">暂无部门数据</span>
    </div>
    
      <div style = "max-height:200px;">
        <scrollLoad style = "max-height:200px;" :pageSize = '20' :list = 'data1'>
          <template v-slot:default="slotProps">
            <div v-for="_item in slotProps.list" :key="_item.id">
              <Checkbox
                v-if="objFilter[_item.id]"
                class="checkbox"
                :label="_item.id"
                v-model = '_item.checked'
                @on-change="checkboxChange1(_item)"
                >{{ _item.title }} <span v-if="_item.supDep !== null" style="color:#9797A8">({{_item.supDep}})</span> </Checkbox
              >
            </div>
          </template>
        </scrollLoad>
      </div>
    
    <span><Icon type="md-people"  size="16" color="#9999A4"/>角色</span>
    <div v-if="data2.length == 0">
      <span style="color:#DCDCDC;">暂无角色数据</span>
    </div>
      <div style = "max-height:200px;">
        <scrollLoad style = "max-height:200px;" :pageSize = '20' :list = 'data2'>
          <template v-slot:default="slotProps">
            <CheckboxGroup
              v-model="checkedData2"
              @on-change="sel=>checkboxChange2(sel, 1)"
            >
              <Checkbox
                class="checkbox"
                v-for="_item in slotProps.list"
                :key="_item.id"
                :label="_item.id"
                v-if="objFilter[_item.id]"
                >{{ _item.title }}</Checkbox
              >
            </CheckboxGroup>
          </template>
        </scrollLoad>
      </div>
    <span><Icon type="md-person"  size="16" color="#9999A4"/>成员</span>
    <div v-if="data3.length == 0">
      <span style="color:#DCDCDC;">暂无成员数据</span>
    </div>
    <div style = "max-height:200px;">
        <scrollLoad style = "max-height:200px;" :pageSize = '20' :list = 'data3'>
          <template v-slot:default="slotProps">
            <CheckboxGroup
              v-model="checkedData3"
              @on-change="sel=>checkboxChange3(sel, 2)"
            >
              <Checkbox
                class="checkbox"
                v-for="_item in slotProps.list"
                :key="_item.id"
                :label="_item.id"
                v-if="objFilter[_item.id]"
                >{{ _item.title }}</Checkbox
              >
            </CheckboxGroup>
          </template>
        </scrollLoad>
    </div>
  </div>
</template>
<script>
import envConst from '@/env-const'
import scrollLoad from './scrollLoad.vue'
export default {
  name: 'searchTree',
  model:{
    prop: 'selectData',
    event: 'on-change'
  },
  props:{
    ipt: String,
    selectData: Array,
    _optionsData: Object,
    defaultData: Array
  },
  components: {
    scrollLoad
  },
  data() {
    return {
      isFocus: false,
      search: false,
      checkedData1: [],
      checkedData2: [],
      checkedData3: [],
      data1:[],
      data2: [],
      data3:[],
      indeterminateData: {}, // 监听tree半选状态，如果是true，则点击两次选中。
      objFilter: {}, // 过滤，接口没有过滤未选上的部门角色人员，前端过滤掉。
    }
  },
  computed:{
    inputData(){
      // 类型为tree时，每此搜索或点击改变，绑定部门已选中的值
      let arr = []
      for(let i in this.selectData){
        arr.push(this.selectData[i].id)
      }
      return arr
    }
  },
  watch: {
    selectData: {
      handler(newValue) {
        if (newValue) {
          this.checkedData1 = []
          this.checkedData2 = []
          this.checkedData3 = []
          newValue.forEach(ele=>{
            let tree = {
              title: ele.title,
              id: ele.id
            }
            if(ele.id.indexOf("dept_")!=-1){
              // this.checkedData1.push(ele.id)
              let selectArr = this.selectData.map(function (item) {
                return item.id;
              });
              for(let i in this.data1){
                let checked = (selectArr.indexOf(this.data1[i].id)>-1)
                this.data1[i].checked = checked
              }
            }
            if(ele.id.indexOf("role_")!=-1){
              this.checkedData2.push(ele.id)
            }
            if(ele.id.indexOf("user_")!=-1){
              this.checkedData3.push(ele.id)
            }
          })
        }
      },
      deep: true,
      immediate: true
    },
    _optionsData: {
      handler(newValue){
        if(newValue){
          // 该组件用于两种情况，一种是从租户拿的数据，部门、角色、人员都是全部的。另一种是从元数据拿的，是配置的时候设置的，所以此种情况需要过滤。
          if(newValue[0].type=='tree'){
            this.dg(newValue[0].list[0],item=>{
              // this.indeterminateData[item.id] = item.indeterminate
              this.objFilter[item.id] = true
            })
          }else if(newValue[0].type=='checkbox'){
            this.dgList(newValue[0].list,item=>{
              this.objFilter[item.id] = true
            })
          }
          this.dgList(newValue[1].list,item=>{
            this.objFilter[item.id] = true
          })
          this.dgList(newValue[2].list,item=>{
            this.objFilter[item.id] = true
          })
        }
        // console.log("过滤",this.objFilter)
      },
      deep: true,
      immediate: true
    }
  },
  created() { },
  mounted() {},
  beforeDestroy() {
  },
  methods: {
    dg(data, cb){
      if(data){
        cb && cb(data)
        if(data.children){
          for(let i in data.children){
            this.dg(data.children[i], cb)
          }
        }
      }
    },
    dgList(data, cb){
      if(data && data.length){
        for(let i in data){
            cb && cb(data[i])
            this.dgList(data[i].list, cb)
          }
      }
    },
    _getItem(id,val){
      let type = this._optionsData[0].type
      let list = type === 'tree'?this._optionsData[0].list[0]:this._optionsData[0].list
      let returnItem = null
      if(type === 'tree'){
        this.dg(list,item => {
            if(id == item.id){
              returnItem = item
            }
        })
      }else{
        let selectIds = this.selectData.map(item => {
          return item.id
        })
        let checked = (selectIds.indexOf(id) > -1)
        returnItem = {
          title: val.depName,
          id,
          checked
        }
      }
      return returnItem
    },
    _getCheckedItem(){
      let checkedList = []
      let type = this._optionsData[0].type
      let list = type === 'tree'?this._optionsData[0].list[0]:this._optionsData[0].list
      let returnItem = null
      if(type === 'tree'){
        this.dg(list,item => {
            if(item.checked){
              checkedList.push(item)
            }
        })
      }else{
        list.forEach(item => {
          if(item.checked){
            checkedList.push(item)
          }
        })
      }
      return checkedList
    },
    request(){
      let that = this;
      that.$http.get('/sctm/ScwfOpenapi/getUsersOrgsRolesByCondition', {
        params: { 
          "tenantId": that.$store.state.main.user.info.tenantId,
          "condition": that.ipt
        }
      }).then(res => {
        let selectArr = that.selectData.map(function (item) {
          return item.id;
        });
        that.data1 = [];
        that.data2 = [];
        that.data3 = [];
        this.checkedData1 = [];
        this.checkedData2 = [];
        this.checkedData3 = [];
        if(res.data.returnCode === 0){
          console.log(res.data)
          if(res.data.bean.depInfo.length != 0){
            for(let val of res.data.bean.depInfo){
              let checked = (selectArr.indexOf('dept_'+val.depId)>-1)
              let tree = {};
              let pushData = this._getItem('dept_'+val.depId,val)
              if(pushData && this.objFilter[pushData.id]){
                pushData.supDep = val.supDep
                that.data1.push(pushData)
              }
            } 
          }else{
            that.data1 = [];
          }
          if(res.data.bean.roleInfo.length != 0){
            for(let val of res.data.bean.roleInfo){
              let tree = {};
              if(selectArr.indexOf('role_'+val.roleId) !== -1){
                tree = {
                  title: val.roleName,
                  id: 'role_'+val.roleId
                }
                this.checkedData2.push('role_'+val.roleId)
              }else{
                tree = {
                  title: val.roleName,
                  id: 'role_'+val.roleId,
                }
              }
              if(this.objFilter[tree.id]){
                that.data2.push(tree)
              }
            } 
          }else{
            that.data2 = [];
          }
          if(res.data.bean.staffInfo.length != 0){
            for(let val of res.data.bean.staffInfo){
              let tree = {};
              if(selectArr.indexOf('user_'+val.staffId) !== -1){
                tree = {
                  title: val.staffName,
                  id: 'user_'+val.staffId
                }
                this.checkedData3.push('user_'+val.staffId)
              }else{
                tree = {
                  title: val.staffName,
                  id: 'user_'+val.staffId,
                }
              }
              if(this.objFilter[tree.id]){
                that.data3.push(tree)
              }
            } 
          }else{
            that.data3 = [];
          }
        }
      })
      .catch(function(err) {
        console.log(err)
      })
    },
    checkboxChange1(selected){
      let type = this._optionsData[0].type
      if(type == 'tree'){
        this.$emit('fatherMethod12',this._getCheckedItem())
      }else{
        this.$emit('depListChange',this.data1)
      }
    },
    checkboxChange2(selected,index){
      let _s = [...selected]
      let _sArr = []
      for(let i in this.data2){
        if(_s.indexOf(this.data2[i].id)!=-1){
          _sArr.push(this.data2[i])
        }
      }
      this.$emit('parentListChange',{selected: _sArr,index,list: this.data2});
    },
    checkboxChange3(selected,index){
      let _s = [...selected]
      let _sArr = []
      for(let i in this.data3){
        if(_s.indexOf(this.data3[i].id)!=-1){
          _sArr.push(this.data3[i])
        }
      }
      this.$emit('parentListChange',{selected: _sArr,index,list: this.data3});
    }
  }
}
</script>
<style lang="stylus" scoped>
.checkbox
  display block
  margin 5px 0
#searchTree .ivu-icon
  position relative
  bottom 2px
  right 2px
#searchTree span+div
  position relative
  bottom 2px
  right 2px
  margin-left 18px
</style>